/* eslint-disable */
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import BindContext from '../../../context/BindProvider';
import { setStorage, getStorage } from '../../../helpers/general';
import Head from '../../atoms/Head/Head';
import Footer from '../Footer/v2/Footer';
import Header from '../Header/v2/Header';
// CSS not modular here to provide global styles
import { useLocation } from '@reach/router';
import SimpleFooter from '../../atoms/SimpleLayouts/SimpleFooter';
import SimpleHeader from '../../atoms/SimpleLayouts/SimpleHeader';
import './Layout.css';
import * as styles from './Layout.module.css';
import queryString from 'query-string';
import useSegment from 'hooks/useSegment';
import { Helmet } from 'react-helmet';
import favIconPc from '../../../../static/favicon.ico';
import favIconMp from '../../../../static/mp_favicon.ico';
import { useParams } from 'hooks/useParams';
import { isMadPawsStore } from '../../../common/util';
import JoinClubModal from '../../molecules/JoinClubModal/JoinClubModal';
import Sidebar from '../../molecules/JoinClubSidebar/JoinClubSidebar';

const simpleLayout = ['confirm-order', 'checkout', 'order-confirmation'];
const Layout = ({ children, className, slim = false, disablePaddingBottom = false }) => {
  const { pathname, search } = useLocation();
  const orderId = useParams('orderId');

  const { identifyManual } = useSegment();
  const bind = useContext(BindContext);
  const initBind = bind && bind.init;

  const [showLightbox, setShowLightbox] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  useEffect(() => {
    if (isMadPawsStore() && typeof window !== 'undefined' && pathname.includes('/blog')) {
      window.location = '/';
    }
    const delay = 2000;
    const timeoutId = setTimeout(() => {
      const parsed = queryString.parse(search);
      if (typeof window !== 'undefined' && window.gtag && parsed.gclid) {
        window.gtag('get', 'G-XXXXXX', 'client_id', function(clientId) {
          identifyManual({
            gclid: parsed.gclid,
            gacid: clientId
          });
        });
      }
    }, delay);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    const currentDate = new Date().getTime();
    const isExpired = parseInt(getStorage('clubExpiryDate')) < currentDate;
    let isNewUser = getStorage('isClubNewUser') === null;
    const isNotSubmitted = getStorage('isClubSubmitted') === null;
    const isTargetUrl = !['/checkout', '/pet-chemist-club', '/pet-chemist-club-stg'].includes(
      window.location.pathname.replace(/\/$/, '')
    );
    if (window.location.href.includes('staging--petchemist')) {
      isNewUser = false;
    }
    if (isTargetUrl && isNotSubmitted && (isExpired || isNewUser)) {
      setShowLightbox(true);

      const expiryDaysinMs = 90 * 24 * 60 * 60 * 1000; // 90 Days
      const expiryDate = currentDate + expiryDaysinMs;

      setStorage('isClubNewUser', 'false', false);
      setStorage('clubExpiryDate', expiryDate.toString(), false);
    }
  }, []);

  const handleCloseLightbox = () => {
    setShowLightbox(false);
    setShowSidebar(true);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  const handleOpenSidebar = isOpen => {
    if (!showLightbox) {
      setShowLightbox(isOpen);
      setShowSidebar(!isOpen);
    }
  };

  const data = {
    site: {
      siteMetadata: {
        title: isMadPawsStore() ? 'Madpaws Store' : 'Pet Chemist'
      }
    }
  };

  if (
    typeof window !== 'undefined' &&
    ['/login', '/login/', '/signup', '/signup/', '/forgotpassword', '/forgotpassword/'].indexOf(
      window.location.pathname
    ) === -1
  ) {
    setStorage('lastPage', window.location.href, true);
  }

  // useEffect(() => {
  //   if (messages.length === 0 && !fetchedMessages) {
  //     setFetchedMessages(true);
  //     const fetchedMessages = data.allBuilderModels.globalInfoBannerContent.map((message) => {
  //       return {
  //         text: message.data.text.replace(/\*(.*?)\*/g, '<strong>$1</strong>'),
  //         link: message.data.link,
  //       }
  //     });
  //     setMessages(fetchedMessages);
  //   }
  //   initBind()
  // }, [initBind, data, messages, setMessages, fetchedMessages, setFetchedMessages])

  const messages = [{ text: 'This is a hardcoded example message', link: '/shop/shop-all' }];

  useEffect(() => {
    initBind();
  }, [initBind]);

  useEffect(() => {
    async function importCSS() {
      if (isMadPawsStore()) {
        await import('./Globals.mps.css');
      } else {
        await import('./Globals.css');
      }
    }

    importCSS();
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined' && isMadPawsStore() && orderId) {
      // PostHog script initialization
      !(function(t, e) {
        var o, n, p, r;
        e.__SV ||
          ((window.posthog = e),
          (e._i = []),
          (e.init = function(i, s, a) {
            function g(t, e) {
              var o = e.split('.');
              2 == o.length && ((t = t[o[0]]), (e = o[1])),
                (t[e] = function() {
                  t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                });
            }
            ((p = t.createElement('script')).type = 'text/javascript'),
              (p.async = !0),
              (p.src =
                s.api_host.replace('.i.posthog.com', '-assets.i.posthog.com') + '/static/array.js'),
              (r = t.getElementsByTagName('script')[0]).parentNode.insertBefore(p, r);
            var u = e;
            for (
              void 0 !== a ? (u = e[a] = []) : (a = 'posthog'),
                u.people = u.people || [],
                u.toString = function(t) {
                  var e = 'posthog';
                  return 'posthog' !== a && (e += '.' + a), t || (e += ' (stub)'), e;
                },
                u.people.toString = function() {
                  return u.toString(1) + '.people (stub)';
                },
                o = 'capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys onSessionId'.split(
                  ' '
                ),
                n = 0;
              n < o.length;
              n++
            )
              g(u, o[n]);
            e._i.push([i, s, a]);
          }),
          (e.__SV = 1));
      })(document, window.posthog || []);
      posthog.init('phc_pz3gfok861yCxUtpE4IEkiVjzQljIiKj7E6FvtDfq9K', {
        api_host: 'https://us.i.posthog.com'
      });
    }
  }, []);

  return (
    <>
      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                                                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                                                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                                                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                                              })(window,document,'script','dataLayer','AW-882086929');`
        }}
      />
      <Head>
        <link rel="canonical" href={process.env.SITE_URL + pathname} />
      </Head>
      <Helmet
        link={[{ rel: 'icon', type: 'image/ico', href: isMadPawsStore() ? favIconMp : favIconPc }]}
      ></Helmet>

      {simpleLayout.includes(pathname.replace(/\//g, '')) ? (
        <SimpleHeader />
      ) : (
        <Header siteTitle={data.site.siteMetadata?.title || `Title`} messages={messages} />
      )}

      <JoinClubModal
        show={showLightbox}
        handleClose={handleCloseLightbox}
        handleSidebarClose={handleSidebarClose}
      />
      {!showLightbox && <Sidebar show={showSidebar} handleOpen={handleOpenSidebar} />}

      <main
        className={`${styles.main} ${isMadPawsStore() && styles.mainMps} ${className} ${
          disablePaddingBottom === true ? styles.disablePaddingBottom : ''
        }`}
      >
        {children}
      </main>

      {simpleLayout.includes(pathname.replace(/\//g, '')) ? <SimpleFooter /> : <Footer />}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
